import { useHistory } from "react-router-dom";
import { getPath } from "common/routing";
import { colors } from "../../../stitches.config";
import { GuestLocationState } from "../../Guest";
import Layout from "../../Guest/Layout";
import ResetForm, { ResetFormProps } from "./ResetForm";

export const GuestPasswordReset = (props: ResetFormProps) => {
  const history = useHistory();

  const onLoginClick = () =>
    history.push(getPath("guestHome"), {
      openLoginModal: true,
    } satisfies GuestLocationState);

  return (
    <Layout
      backgroundColor={colors.bgUiContainerInverted}
      footerFontColor={"contentPrimaryInverted"}
    >
      <ResetForm {...props} onLoginClick={onLoginClick} />
    </Layout>
  );
};
